// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TableTokens } from './type';

const tableTokens: TableTokens = {
  tableFontSize: '14/regular',
  tableCellPaddingX: 'Padding-12',
  tableCellPaddingY: 'Padding-8',
  tableCellBorderColor: 'Neutral-border-1',
  tableSmallCellPaddingX: 'Padding-8',
  tableSmallCellPaddingY: 'Padding-4',
  tableLargeCellPaddingX: 'Padding-16',
  tableLargeCellPaddingY: 'Padding-16',
  tableFixedShadow: 'rgba(2,11,24,.1)',
  tableTheadBackgroundColor: 'Neutral-fill-2',
  tableTheadFontColor: 'Neutral-text-5',
  tableTbodyBackgroundColor: 'Neutral-fill-1',
  tableTbodyStripedBackgroundColor: 'Neutral-fill-2',
  tableTbodyHoverBackgroundColor: 'Indigo-1',
  tableTbodyActiveBackgroundColor: 'Brand-1',
  tableTbodyFontColor: 'Neutral-text-5',
  tableTfootBackgroundColor: 'Neutral-fill-2',
  tableTfootFontColor: 'Neutral-text-5',
  tableExpandIconSize: 'Size-7',
  tableExpandIconColor: 'Neutral-text-2',
  tableExpandIconHoverBackgroundColor: 'Neutral-fill-3',
  tableExpandBackgroundColor: 'Neutral-fill-2',
  tableSorterColor: 'Neutral-text-3',
  tableSorterHoverColor: 'Neutral-text-4',
  tableSorterActiveColor: 'Brand-6',
  tableResizeColor: 'Brand-7',
  tableSelectionBorderColor: 'Brand-6',
  tablePaginationMarginY: 'Margin-12',
};

export default tableTokens;
